import { _ as _objectSpread2 } from '../../_rollupPluginBabelHelpers-fb970440.js';
import { makeVar } from '@apollo/client';

var init_state_quote = {
  quoteNumber: '',
  isCopyFromOutside: false,
  isPremiumCalculating: null,
  currentTab: 0,
  proposalNumber: '',
  isApprover: '',
  uw_role_name: '',
  quoteCreationDate: '',
  status: '',
  intermediaryDetails: {
    code: '',
    location: '',
    fieldUserCode: '',
    fieldUserName: ''
  },
  finalisedPremium: {
    locationNetPremium: '',
    locationGST: '',
    locationTotalPremium: '',
    stampDuty: ''
  },
  district: '',
  pincode: '',
  productKg: '',
  state: '',
  eqZone: '',
  locationCode: '',
  pinCodeLocality: '',
  city: '',
  addOnCovers: {},
  customerDetails: {
    customerType: {
      code: '',
      value: ''
    },
    orgInsuredName: '',
    firstName: '',
    middleName: '',
    lastName: ''
  },
  riskcoverdata: [],
  coverData: {
    addOnCovers: [],
    rawRiskData: []
  },
  otherDetails: {
    premisesRentedOut: '',
    ownerOccupant: ''
  },
  loadingAndDiscount: {
    discountPercentage: '',
    loadingPercentage: ''
  },
  pendingMessage: '',
  tabDetails: {
    customerTabDetails: {
      customerDetails: {
        customer: {},
        customerMeta: {},
        // customerType: {
        //   code: '',
        //   value: '',
        // },
        // firstName: '',
        // middleName: '',
        // lastName: '',
        businessOfInsured: '' // orgInsuredName: '',

      },
      previousClaimExperienceDetails: {
        isClaimMadeInPreviousYears: 'No',
        claimInPreviousYearsInfo: ''
      },
      policyTypeDetails: {
        isInsuranceForKutchaConstruction: 'No',
        policyOrCoverType: {
          code: '',
          value: ''
        },
        tenure: {
          code: '',
          value: ''
        },
        policyStartDate: '',
        policyExpiryDate: ''
      }
    },
    riskLocationTabDetails: {
      addOnCovers: {},
      floaterType: {
        occupancy: {
          code: '',
          value: '',
          occupancySection: '',
          occupancyRate: '',
          riskCode: '',
          rateCode: '',
          riskGrade: '',
          riskGradeDefinition: '',
          riskPreference: '',
          gicClass: '',
          stfiRate: '',
          rsmdRate: ''
        },
        riskLocationID: '',
        floaterLocations: [],
        riskSumInsured: {
          stocksSI: '',
          stocksInProcessSI: '',
          stocksOnFloaterBasis: '',
          maximumStockSIAtOneLocation: ''
        },
        fireExtinguisherAppliancesDetails: [],
        otherDetails: {
          classOfConstruction: '',
          distanceFromWaterbody: '',
          securityProvisions: ''
        },
        loadingAndDiscount: {
          discountPercentage: '',
          loadingPercentage: ''
        },
        previousClaimDetails: {
          claimExperience: ''
        },
        locationPremium: {
          locationNetPremium: '',
          locationGST: '',
          locationTotalPremium: '',
          stampDuty: ''
        }
      },
      nonFloaterType: []
    },
    additionalTabDetails: {
      warranties: {
        defaultWarranties: [],
        userDefinedWarranties: []
      },
      exclusions: {
        defaultExclusions: [],
        userDefinedExclusions: []
      },
      clauses: {
        defaultClauses: [],
        userDefinedClauses: []
      },
      conditions: {
        defaultConditions: [],
        userDefinedConditions: []
      },
      underwriterComment: ''
    }
  }
};
var init_state_upload_documents = {
  documentDetails: []
};
var fireQuoteVar = makeVar(init_state_quote);
var fireQuoteAdditionalDetailsUploadDocsVar = makeVar(init_state_upload_documents);
var initFireQuoteState = function initFireQuoteState(isCopyFromOutside) {
  var _fireQuoteVar;

  if (isCopyFromOutside && (_fireQuoteVar = fireQuoteVar()) !== null && _fireQuoteVar !== void 0 && _fireQuoteVar.isCopyFromOutside) {
    fireQuoteVar(_objectSpread2(_objectSpread2({}, fireQuoteVar()), {}, {
      isCopyFromOutside: false,
      isQuoteCopied: isCopyFromOutside
    }));
    return true;
  }

  fireQuoteVar(init_state_quote);
  fireQuoteAdditionalDetailsUploadDocsVar(init_state_upload_documents);
  return false;
};
var updateFireQuote = function updateFireQuote(data) {
  fireQuoteVar(_objectSpread2(_objectSpread2(_objectSpread2({}, fireQuoteVar()), data), {}, {
    get_risk_location: true
  }));
};
var updateFireQuoteUploadDocsVar = function updateFireQuoteUploadDocsVar(documentDetails) {
  fireQuoteAdditionalDetailsUploadDocsVar(_objectSpread2({}, documentDetails));
};

export { fireQuoteAdditionalDetailsUploadDocsVar, fireQuoteVar, initFireQuoteState, init_state_quote, init_state_upload_documents, updateFireQuote, updateFireQuoteUploadDocsVar };
